'use client';

import { motion, AnimatePresence } from 'framer-motion';

/**
 * КОМПОНЕНТ ФОНОВЫХ ПОТОКОВ ДАННЫХ (Data Stream Drift)
 * Создает эффект ультра-тонких светящихся линий с ромбиками, дрейфующих на заднем плане.
 */
export default function PricingBackground() {
  const streams = [
    { id: 1, start: { x: -100, y: 100 }, end: { x: 1100, y: 700 }, duration: 20, delay: 0 },
    { id: 2, start: { x: 300, y: -100 }, end: { x: 800, y: 1100 }, duration: 25, delay: 4 },
    { id: 3, start: { x: -200, y: 400 }, end: { x: 1200, y: 800 }, duration: 18, delay: 8 },
    { id: 4, start: { x: 500, y: -100 }, end: { x: 200, y: 1100 }, duration: 22, delay: 2 },
    { id: 5, start: { x: 900, y: 200 }, end: { x: -100, y: 900 }, duration: 30, delay: 6 },
  ];

  return (
    <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
      {/* Deep Background Gradient Base */}
      <div className="absolute inset-0 bg-[#020617]" />

      {/* Shapes (Matching Hero) */}
      <div className="absolute -top-[15%] -left-[10%] w-[60vw] h-[60vw] bg-blue-600/20 rounded-full blur-[120px] animate-pulse" />
      <div className="absolute top-[10%] -right-[20%] w-[55vw] h-[55vw] bg-indigo-500/15 rounded-full blur-[100px]" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-400/10 rounded-full blur-[80px]" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-indigo-400/10 rounded-full blur-[70px]" />

      {/* Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

      {/* Data Streams SVG */}
      <div className="absolute inset-0 opacity-30">
        <svg className="w-full h-full" viewBox="0 0 1000 1000" preserveAspectRatio="none">
          <defs>
            <linearGradient id="trailGradient" x1="1" y1="1" x2="0" y2="0">
              <stop offset="0%" stopColor="rgba(255, 255, 255, 0.9)" />
              <stop offset="100%" stopColor="rgba(59, 130, 246, 0)" />
            </linearGradient>
          </defs>
          <AnimatePresence>
            {streams.map((stream) => (
              <StreamGroup key={stream.id} {...stream} />
            ))}
          </AnimatePresence>
        </svg>
      </div>
    </div>
  );
}

function StreamGroup({ start, end, duration, delay }: any) {
  return (
    <g>
      <StreamLine start={start} end={end} duration={duration} delay={delay} />
      <StreamLine start={start} end={end} duration={duration} delay={delay + duration / 2} />
    </g>
  );
}

function StreamLine({ start, end, duration, delay }: any) {
  return (
    <motion.g
      initial={{ x: start.x, y: start.y, opacity: 0 }}
      animate={{
        x: [start.x, end.x],
        y: [start.y, end.y],
        opacity: [0, 1, 1, 0]
      }}
      transition={{
        duration: duration,
        repeat: Infinity,
        ease: "linear",
        delay: delay,
        times: [0, 0.1, 0.9, 1]
      }}
    >
      <line
        x1="0" y1="0"
        x2={-(end.x - start.x) * 0.12}
        y2={-(end.y - start.y) * 0.12}
        stroke="url(#trailGradient)"
        strokeWidth="0.5"
        style={{ filter: "drop-shadow(0 0 2px rgba(147, 197, 253, 0.5))" }}
      />
      <path
        d="M -2.5 0 L 0 -2.5 L 2.5 0 L 0 2.5 Z"
        fill="white"
        style={{ filter: "drop-shadow(0 0 4px rgba(255, 255, 255, 0.8))" }}
      />
    </motion.g>
  );
}
